/**
 * Schema Explorer insertion-format policy (see plan: Embedded Schema Explorer).
 *
 * - Table click       → "TABLE"   (or "SCHEMA.TABLE" when a schema is provided)
 * - Column click      → "TABLE.COLUMN"
 * - Field result click → "TABLE.COLUMN"
 *
 * Identifiers are not quoted (matches existing SQL style in the repo).
 * A leading single space is prepended when the previous character is non-whitespace
 * and not one of `(`, `,`, `.`.
 */

export type SchemaSnippetInput =
    | { kind: 'table'; table: string; schema?: string | null }
    | { kind: 'column'; table: string; column: string }
    | { kind: 'field'; table: string; column: string };

export function formatSchemaSnippet(input: SchemaSnippetInput): string {
    switch (input.kind) {
        case 'table':
            return input.schema ? `${input.schema}.${input.table}` : input.table;
        case 'column':
        case 'field':
            return `${input.table}.${input.column}`;
    }
}

/**
 * Returns the snippet with a leading space when needed so it does not bump
 * against the preceding identifier / operator.
 */
export function applyLeadingSpace(snippet: string, prevChar: string | undefined): string {
    if (!prevChar) return snippet;
    if (/\s/.test(prevChar)) return snippet;
    if (prevChar === '(' || prevChar === ',' || prevChar === '.') return snippet;
    return ' ' + snippet;
}
